import { IEquipeUsuario } from "../../../Interfaces/HelpDesk/Equipes/EquipeInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarUsuariosVincladoPorEquipeService(idEquipe: number) {
    return Service(
        Axios.get<Array<IEquipeUsuario>>(
            `/helpdesk/gestaodeequipeshelpdesk/listarusuariosvinculadosporequipehelpdesk?IdEquipe=${idEquipe}`
        )
    );
}

export async function ListarUsuariosNaoVincladoPorEquipeService(
    idEquipe: number
) {
    return Service(
        Axios.get<Array<IEquipeUsuario>>(
            `/helpdesk/gestaodeequipeshelpdesk/listarusuariosnaovinculadosporequipehelpdesk`
        )
    );
}

export async function VincularUsuarioEquipeService(
    requestBody: IEquipeUsuario
) {
    return Service(
        Axios.post(
            `/helpdesk/gestaodeequipeshelpdesk/vincularusuarioequipehelpdesk`,
            requestBody
        )
    );
}

export async function DesvincularUsuarioEquipeService(
    requestBody: IEquipeUsuario
) {
    return Service(
        Axios.post(
            `/helpdesk/gestaodeequipeshelpdesk/desvincularusuarioequipehelpdesk`,
            requestBody
        )
    );
}
